// NewService.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "./Api";
import "./NewService.css";
import AlertModal from "./AlertModal";
import API_URL from "../config";

export default function ReglementService({ k, onClose }) {
  // const token = localStorage.getItem("access_token"); // récupérer le JWT
  const [clientName, setClientName] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [mtattendu, setmtattendu] = useState("");
  const [mtattendu2, setmtattendu2] = useState(0);
  const [mtremise, setmtremise] = useState(0);
  const [nbreserv, setNbreserv] = useState(""); // ID réel
  const [btips1, setbtips1] = useState(false);
  const [btips2, setbtips2] = useState(false);
  const [btips4, setbtips4] = useState(false);
  const [btips3, setbtips3] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [tresse2, settresse2] = useState(false);
  const [tresse3, settresse3] = useState(false);
  const [blav, setblav] = useState(false);
  const [laveuse, setlaveuse] = useState("");
  const [idservice, setIdService] = useState(""); // ID réel
  const [codservice, setCodService] = useState(""); // ID réel
  const [mtpaye1, setmtpaye1] = useState(0);
  const [mtpaye2, setmtpaye2] = useState(0);
  const [mtpaye12, setmtpaye12] = useState("");
  const [mtpaye22, setmtpaye22] = useState("");
  const [mttres1, setmttres1] = useState(0);
  const [mttres2, setmttres2] = useState(0);
  const [mttres3, setmttres3] = useState(0);
  const [mttres12, setmttres12] = useState("");
  const [mttres22, setmttres22] = useState("");
  const [mttres32, setmttres32] = useState("");
  const [prixWash, setPrixWash] = useState(0);
  const [nbtresvar, setnbtresvar] = useState(0);
  const [prixserv, setPrixServ] = useState(0);
  const [wahCode, setwahCode] = useState("NON");
  const [mtlav, setmtlav] = useState(0);
  const [mtlav11, setmtlav11] = useState("");
  const [codtres1, setCodtres1] = useState("NON");
  const [codtres2, setCodtres2] = useState("NON");
  const [codtres3, setCodtres3] = useState("NON");
  const [tips1, settips1] = useState(0);
  const [tips2, settips2] = useState(0);
  const [tips3, settips3] = useState(0);
  const [tips4, settips4] = useState(0);
  const [tips12, settips12] = useState("");
  const [tips22, settips22] = useState("");
  const [tips32, settips32] = useState("");
  const [tips42, settips42] = useState("");
  const [tresseuse1, setTresseuse1] = useState("");
  const [tresseuse2, setTresseuse2] = useState("");
  const [tresseuse3, setTresseuse3] = useState("");
  const [nbTresseuses, setNbTresseuses] = useState(1);
  const [modreglement, setShop] = useState("Choose Payment Method");
  const [modreglement2, setShop2] = useState("Choose Payment Method");
  //const [prixService, setPrixService] = useState(0);
  const [wahName, setwahName] = useState("");
  const [ldate, setLdate] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  /*  const [showModal2, setShowModal2] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const CODE_SECRET = "1234";

  const handleCheckboxClick = (e) => {
    e.preventDefault(); // empêche le check direct
    setShowModal2(true);
  };

  const validateCode = () => {
    if (code === CODE_SECRET) {
      setAvecRemise(true);
      setShowModal2(false);
      setError("");
      setCode("");
    } else {
      setError("Code incorrect");
      setAvecRemise(false);
      setmtremise("");
    }
  };
*/
  const showModalAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };
  const formatDollar = (amount) => {
    if (amount == null) return "$0.00"; // gestion des valeurs nulles
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };
  // Convertir k en nom client
  useEffect(() => {
    if (k) {
      const parts = k.split("@@");
      setClientName(parts[0] + "---" + parts[1]);
      setLdate(parts[4]);
      setNbreserv(parts[2]);
      setClientCode(parts[0]);
      setIdService(parts[5]);
      setCodService(parts[6]);
    }
  }, [k]);

  useEffect(() => {
    // Formatter les montants
    setmtpaye12(formatDollar(Number(mtpaye1)));
    setmtpaye22(formatDollar(Number(mtpaye2)));

    const remainingAmount =
      Number(mtpaye1) + Number(mtpaye2) + Number(mtremise) - Number(mtattendu2);

    if (remainingAmount > 0) {
      // Calculer le nombre de tresseuses à utiliser
      const effectiveNbTresseuses =
        prixWash > 0 ? Number(nbTresseuses) + 1 : Number(nbTresseuses);

      const amountPerBraider = remainingAmount / effectiveNbTresseuses;

      // Tableau des setters pour tips et tips formaté
      const tipSetters = [
        { setTip: settips1, setTipFormatted: settips12, setBt: setbtips1 },
        { setTip: settips2, setTipFormatted: settips22, setBt: setbtips2 },
        { setTip: settips3, setTipFormatted: settips32, setBt: setbtips3 },
      ];

      tipSetters.forEach(({ setTip, setTipFormatted, setBt }, index) => {
        if (index < nbTresseuses) {
          setTip(amountPerBraider);
          setTipFormatted(amountPerBraider);
          setBt(true);
        } else {
          setTip(0);
          setTipFormatted(0);
          setBt(false);
        }
      });

      // Ajouter la quatrième tip si wash > 0
      if (prixWash > 0) {
        settips4(amountPerBraider);

        setbtips4(true);
      }
    } else {
      // Si rien à répartir, désactiver tous les tips
      settips1(0);
      settips12(0);
      setbtips1(false);

      settips2(0);
      settips22(0);
      setbtips2(false);

      settips3(0);
      settips32(0);
      setbtips3(false);

      settips4(0);
      settips42(0);
      setbtips4(false);
    }
  }, [mtattendu2, mtpaye1, mtpaye2, nbTresseuses, mtremise, prixWash]);

  useEffect(() => {
    if (nbreserv && clientCode) {
      ChargeInfoClientService(nbreserv, clientCode, ldate, {
        setServiceName,

        setmtattendu2,
        setlaveuse,
        setNbTresseuses,
        setTresseuse1,
        setTresseuse2,
        setTresseuse3,
        setwahName,
        setCodtres1,
        setCodtres2,
        setCodtres3,
        setwahCode,
        setIdService,
        setCodService,
        setPrixWash,
        settresse2,
        settresse3,
        setblav,
        setmtattendu,
        setbtips1,
        setPrixServ,
        setmttres1,
        setmttres12,
        setmttres2,
        setmttres22,
        setmttres3,
        setmttres32,
        setmtlav,
        setmtlav11,
        setNbreserv,
      });
    }
  }, [nbreserv, clientCode, ldate]);

  const ChargeInfoClientService = async (codserv, codclt, ldate, setters) => {
    try {
      const res = await axios.post(`${API_URL}/info-client-service/`, {
        mat: codserv,
        lclts: codclt,
        ldate: ldate,
      });

      const { service, tresseuses, nbre_service_jour } = res.data;

      // setters.setCodService(service.codeserv);
      //  setters.setIdService(service.idserv);

      setters.setServiceName(service.name);
      //setters.setPrixService(service.prix_service);
      const prixWash2 = Number(service.prix_wash) || 0;
      const prixservice = Number(service.prix_service) || 0;
      const prixmeche = Number(service.prix_meche) || 0;
      const prixsrv = prixservice - prixWash2 - prixmeche;

      setters.setPrixServ(prixsrv);

      setters.setPrixWash(service.prix_wash);
      setters.setmtattendu2(prixservice);

      setters.setmtattendu(formatDollar(prixservice));
      setters.setbtips1(false);
      setters.setNbTresseuses(1);
      //  setters.setNbreserv(nbre_service_jour);

      // Gestion tresseuses
      const nb = tresseuses.length;
      const hasWash = Number(prixWash2) > 0;

      // ==========================
      // Helpers
      // ==========================
      const setTresseuse = (index, t, montant) => {
        setters[`setTresseuse${index}`](`${t.name} (${t.code})`);
        setters[`setCodtres${index}`](t.codeid);
        setters[`setmttres${index}`](montant);
        setters[`setmttres${index}2`](formatDollar(montant));

        if (index > 1) setters[`settresse${index}`](true);
      };

      const setLaveuse = (t, montant) => {
        setters.setblav(true);
        setters.setlaveuse(`${t.name} (${t.code})`);
        setters.setwahCode(t.codeid);
        setters.setmtlav(montant);
        setters.setmtlav11(formatDollar(montant));
      };

      // ==========================
      // Séparation rôles
      // ==========================
      const laveuse = hasWash ? tresseuses[nb - 1] : null;
      const tresses = hasWash ? tresseuses.slice(0, nb - 1) : tresseuses;

      // ==========================
      // Nombre réel de tresseuses
      // ==========================
      setters.setNbTresseuses(tresses.length);

      // ==========================
      // Calcul montants
      // ==========================
      const partTresse =
        tresses.length === 1 ? prixsrv / 2 : prixsrv / (tresses.length * 2);

      const partWash = hasWash ? Number(prixWash2) / 2 : 0;

      // ==========================
      // Appliquer tresseuses
      // ==========================
      tresses.slice(0, 3).forEach((t, i) => {
        setTresseuse(i + 1, t, partTresse);
      });

      // ==========================
      // Appliquer laveuse
      // ==========================
      if (laveuse) {
        setLaveuse(laveuse, partWash);
      }

      /*
      if (tresseuses.length === 1) {
        setters.setTresseuse1(`${tresseuses[0].name} (${tresseuses[0].code})`);
        setters.setCodtres1(`${tresseuses[0].codeid}`);
        const prixsrv2 = prixsrv / 2;
        setters.setmttres1(prixsrv2);
        setters.setmttres12(formatDollar(prixsrv2));
      }

      if (tresseuses.length === 2) {
        setters.setNbTresseuses(2);
        if (Number(prixWash2) > 0) {
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setblav(true);
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setlaveuse(`${tresseuses[1].name} (${tresseuses[1].code})`);
          setters.setwahCode(`${tresseuses[1].codeid}`);
          const prixsrv2 = Number(prixWash2) / 2;
          setters.setmtlav(prixsrv2);
          setters.setmtlav11(formatDollar(prixsrv2));
          const prixsrv21 = prixsrv / 2;
          setters.setmttres1(prixsrv21);
          setters.setmttres12(formatDollar(prixsrv21));
          setters.setNbTresseuses(1);
        } else {
          //    setters.setNbTresseuses(2);
          setters.settresse2(true);
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setCodtres2(`${tresseuses[1].codeid}`);
          const prixsrv21 = prixsrv / 4;
          setters.setmttres1(prixsrv21);
          setters.setmttres12(formatDollar(prixsrv21));

          setters.setmttres2(prixsrv21);
          setters.setmttres22(formatDollar(prixsrv21));
        }
      }

      if (tresseuses.length === 3) {
        setters.setNbTresseuses(3);
        if (Number(prixWash2) > 0) {
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setblav(true);
          setters.settresse2(true);
          setters.setCodtres2(`${tresseuses[1].codeid}`);
          setters.setlaveuse(`${tresseuses[2].name} (${tresseuses[2].code})`);
          setters.setwahCode(`${tresseuses[2].codeid}`);

          const prixsrv2 = Number(prixWash2) / 2;
          setters.setmtlav(prixsrv2);
          setters.setmtlav11(formatDollar(prixsrv2));
          const prixsrv21 = prixsrv / 4;
          setters.setmttres1(prixsrv21);
          setters.setmttres12(formatDollar(prixsrv21));
          setters.setmttres2(prixsrv21);
          setters.setmttres22(formatDollar(prixsrv21));
          setters.setNbTresseuses(2);
        } else {
          setters.settresse2(true);
          setters.settresse3(true);
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setCodtres2(`${tresseuses[1].codeid}`);
          setters.setTresseuse3(
            `${tresseuses[2].name} (${tresseuses[2].code})`,
          );
          setters.setCodtres3(`${tresseuses[2].codeid}`);

          const prixsrv21 = prixsrv / 6;
          setters.setmttres1(prixsrv21);
          setters.setmttres12(formatDollar(prixsrv21));
          setters.setmttres2(prixsrv21);
          setters.setmttres22(formatDollar(prixsrv21));

          setters.setmttres3(prixsrv21);
          setters.setmttres32(formatDollar(prixsrv21));
        }
      }
      if (tresseuses.length === 4) {
        setters.setNbTresseuses(3);
        setters.settresse2(true);
        setters.settresse3(true);
        setters.setblav(true);
        setters.setTresseuse1(`${tresseuses[0].name} (${tresseuses[0].code})`);
        setters.setCodtres1(`${tresseuses[0].codeid}`);
        setters.setTresseuse2(`${tresseuses[1].name} (${tresseuses[1].code})`);
        setters.setCodtres2(`${tresseuses[1].codeid}`);
        setters.setTresseuse3(`${tresseuses[2].name} (${tresseuses[2].code})`);
        setters.setCodtres3(`${tresseuses[2].codeid}`);
        setters.setlaveuse(`${tresseuses[3].name} (${tresseuses[3].code})`);
        setters.setwahCode(`${tresseuses[3].codeid}`);

        const prixsrv21 = prixsrv / 6;
        setters.setmttres1(prixsrv21);
        setters.setmttres12(formatDollar(prixsrv21));
        setters.setmttres2(prixsrv21);
        setters.setmttres22(formatDollar(prixsrv21));

        setters.setmttres3(prixsrv21);
        setters.setmttres32(formatDollar(prixsrv21));
        const prixsrv2 = Number(prixWash2) / 2;
        setters.setmtlav(prixsrv2);
        setters.setmtlav11(formatDollar(prixsrv2));
      }  */
    } catch (error) {
      console.error("Erreur chargement service :", error);
    }
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/read_hist_file/`)
      .then((res) => {
        if (res.data.content) {
          setLdate(res.data.content); // initialise la date directement
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const saveService = async () => {
    if (Number(mtpaye1) === 0) {
      showModalAlert("Please enter the amount paid by the customer. ❌");
      return;
    }

    if (modreglement === "Choose Payment Method") {
      showModalAlert("Please select your payment option for Payment Mode 1 ❌");
      return;
    }

    if (Number(mtpaye2) > 0) {
      if (modreglement2 === "Choose Payment Method") {
        showModalAlert(
          "Please select your payment option for Payment Mode 2 ❌",
        );
        return;
      }
    }
    const mtdiff = Number(mtpaye2) + Number(mtpaye1);
    if (Number(mtattendu) > Number(mtdiff)) {
      showModalAlert("The amount entered is lower than the expected amount ❌");
      return;
    }

    try {
      const payload = {
        client: clientName,
        service: idservice,
        prixService: prixserv,
        prixWash,
        tresseuse1: codtres1,
        tresseuse2: codtres2,
        tresseuse3: codtres3,
        nbTresseuses,
        ldate,
        wahName: wahCode,
        codservice,
        mtpaye1,
        mtpaye2,
        modreglement,
        modreglement2,
        mtattendu2,
        mttres1,
        mttres2,
        mttres3,
        tips1,
        tips2,
        tips3,
        tips4,
        mtlav,
        nbreserv,
        mtremise,
      };
      const response = await api.post("save_reglement/", payload);

      /*   const response = api
        .post("save_reglement/", payload)
        .then((res) => console.log(res.data))
        .catch((err) => console.error(err));*/

      showModalAlert("Save succesfully ✔");

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement !");
    }
  };

  return (
    <div className="container-box">
      <div className="card9" style={{ padding: "20px" }}>
        <h3>PROCEED TO PAY FOR A SERVICE</h3>

        <div className="row3">
          <div className="col-lg-5 col-md-5">
            <label className="field-label">Nom du client</label>
            <input value={clientName} disabled className="input" />
          </div>
          <div className="col-lg-3 col-md-3">
            <label className="field-label">Montant attendu</label>
            <input value={mtattendu} disabled className="input" />
          </div>{" "}
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Today's date</label>
            <input
              type="date"
              value={ldate}
              onChange={(e) => setLdate(e.target.value)}
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Military discount</label>
            <input
              type="number"
              placeholder="0"
              value={mtremise}
              onChange={(e) => setmtremise(e.target.value)}
              className="input"
            />
          </div>
          {/* 
{showModal2 && (
  <div className="modal-overlay">
    <div className="modal">
      <h4>Code secret</h4>

      <input
        type="password"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="modal-actions">
        <button onClick={validateCode}>Valider</button>
        <button onClick={() => setShowModal2(false)}>Annuler</button>
      </div>
    </div>
  </div>
)}
*/}
        </div>
        <div className="row3">
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Payment Mode 1</label>
            <select
              value={modreglement}
              onChange={(e) => setShop(e.target.value)}
              className="input"
            >
              <option>Choose Payment Method</option>
              <option>Cash</option>
              <option>Cashapp</option>
              <option>Venmo</option>
              <option>Zelle</option>
              <option>Credit card</option>
            </select>
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 1</label>
            <input
              type="number"
              placeholder="0"
              value={mtpaye1}
              onChange={(e) => setmtpaye1(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 1</label>
            <input
              type="text"
              placeholder="0"
              value={mtpaye12}
              disabled
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Payment Mode 2</label>
            <select
              value={modreglement2}
              onChange={(e) => setShop2(e.target.value)}
              className="input"
            >
              <option>Choose Payment Method</option>
              <option>Cash</option>
              <option>Cashapp</option>
              <option>Venmo</option>
              <option>Zelle</option>
              <option>Credit card</option>
            </select>
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 2</label>
            <input
              type="number"
              placeholder="0"
              value={mtpaye2}
              onChange={(e) => setmtpaye2(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 2</label>
            <input
              type="text"
              placeholder="0"
              value={mtpaye22}
              disabled
              className="input"
            />
          </div>
        </div>

        <h4>Determining the Service Prices of Braiders</h4>

        {blav && (
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <label className="field-label">
                Braider who performed the wash
              </label>
              <input
                value={laveuse}
                onChange={(e) => setlaveuse(e.target.value)}
                disabled
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mtlav}
                onChange={(e) => setmtlav(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mtlav))}
                disabled
                className="input"
              />
            </div>
            {btips4 && (
              <>
                {" "}
                <div className="col-lg-2 col-md-2">
                  {" "}
                  <label className="field-label">Tip</label>{" "}
                  <input
                    type="number"
                    placeholder="0"
                    value={tips4}
                    onChange={(e) => settips4(e.target.value)}
                    className="input"
                  />{" "}
                </div>{" "}
                <div className="col-lg-2 col-md-2">
                  {" "}
                  <label className="field-label">Tip</label>{" "}
                  <input
                    type="text"
                    placeholder="0"
                    value={formatDollar(Number(tips4))}
                    disabled
                    className="input"
                  />{" "}
                </div>{" "}
              </>
            )}
          </div>
        )}

        <div className="row">
          <div className="col-lg-3 col-md-3">
            <label className="field-label">First Braider</label>
            <input
              value={tresseuse1}
              onChange={(e) => setTresseuse1(e.target.value)}
              disabled
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Allocated Amount</label>
            <input
              type="number"
              placeholder="0"
              value={mttres1}
              onChange={(e) => setmttres1(e.target.value)}
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Allocated Amount</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(mttres1))}
              disabled
              className="input"
            />
          </div>
          {btips1 && (
            <>
              {" "}
              <div className="col-lg-2 col-md-2">
                {" "}
                <label className="field-label">Tip</label>{" "}
                <input
                  type="number"
                  placeholder="0"
                  value={tips1}
                  onChange={(e) => settips1(e.target.value)}
                  className="input"
                />{" "}
              </div>{" "}
              <div className="col-lg-2 col-md-2">
                {" "}
                <label className="field-label">Tip</label>{" "}
                <input
                  type="text"
                  placeholder="0"
                  value={formatDollar(Number(tips1))}
                  disabled
                  className="input"
                />{" "}
              </div>{" "}
            </>
          )}
        </div>

        {tresse2 && (
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <label className="field-label">Second Braider</label>
              <input
                value={tresseuse2}
                onChange={(e) => setTresseuse2(e.target.value)}
                disabled
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mttres2}
                onChange={(e) => setmttres2(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mttres2))}
                disabled
                className="input"
              />
            </div>
            {btips2 && (
              <>
                <div className="col-lg-2 col-md-2">
                  <label className="field-label">Tip</label>
                  <input
                    type="number"
                    placeholder="0"
                    value={tips2}
                    onChange={(e) => settips2(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="col-lg-2 col-md-2">
                  <label className="field-label">Tip</label>
                  <input
                    type="text"
                    placeholder="0"
                    value={formatDollar(Number(tips2))}
                    disabled
                    className="input"
                  />
                </div>
              </>
            )}
          </div>
        )}

        {tresse3 && (
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <label className="field-label">Third Braider</label>
              <input
                value={tresseuse3}
                onChange={(e) => setTresseuse3(e.target.value)}
                disabled
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mttres3}
                onChange={(e) => setmttres3(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mttres3))}
                disabled
                className="input"
              />
            </div>
            {btips3 && (
              <>
                <div className="col-lg-2 col-md-2">
                  <label className="field-label">Tip</label>
                  <input
                    type="number"
                    placeholder="0"
                    value={tips3}
                    onChange={(e) => settips3(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="col-lg-2 col-md-2">
                  <label className="field-label">Tip</label>
                  <input
                    type="text"
                    placeholder="0"
                    value={formatDollar(Number(tips3))}
                    disabled
                    className="input"
                  />
                </div>{" "}
              </>
            )}
          </div>
        )}

        <div className="row">
          <button className="btn" onClick={saveService}>
            Save
          </button>
          <button
            className="btn red"
            onClick={() => {
              if (onClose) onClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
      <AlertModal
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </div>
  );
}
// Styles
